var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookInvertedLight = function SvgFacebookInvertedLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.502,
    cy: 22.439,
    r: 21.068,
    stroke: "#494949",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.92 20.286v-2.073c0-.572.44-1.036.983-1.036h.981v-2.591h-1.963c-1.627 0-2.946 1.392-2.946 3.109v2.59h-1.963v2.592h1.963v8.29h2.946v-8.29h1.963l.982-2.591h-2.945Z"
  })));
};
export { SvgFacebookInvertedLight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIyMi41MDE4IiBjeT0iMjIuNDM5MyIgcj0iMjEuMDY4MiIgc3Ryb2tlPSIjNDk0OTQ5IiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDxwYXRoIGQ9Ik0yMy45MjA4IDIwLjI4NTlWMTguMjEzMkMyMy45MjA4IDE3LjY0MTEgMjQuMzYwNyAxNy4xNzY4IDI0LjkwMjYgMTcuMTc2OEgyNS44ODQ0VjE0LjU4NTlIMjMuOTIwOEMyMi4yOTM5IDE0LjU4NTkgMjAuOTc1NCAxNS45Nzc4IDIwLjk3NTQgMTcuNjk1VjIwLjI4NTlIMTkuMDExN1YyMi44NzY4SDIwLjk3NTRWMzEuMTY3OEgyMy45MjA4VjIyLjg3NjhIMjUuODg0NEwyNi44NjYzIDIwLjI4NTlIMjMuOTIwOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==";